import { useInView } from '../../../hooks/useInView';

const values = [
  {
    icon: 'ri-sun-line',
    label: 'Faith-Centered',
    desc: 'Every seed planted in trust and thanksgiving to our Creator',
  },
  {
    icon: 'ri-group-line',
    label: 'Family First',
    desc: 'Working the land together, building bonds that last a lifetime',
  },
  {
    icon: 'ri-heart-3-line',
    label: 'Community Love',
    desc: 'Sharing our harvest and blessings with neighbors near and far',
  },
];

export default function About() {
  const { ref, inView } = useInView(0.1);

  return (
    <section id="about" className="w-full bg-[#EDF4EB] py-24 px-8 lg:px-16">
      <div
        ref={ref}
        className={`max-w-6xl mx-auto transition-all duration-1000 ${
          inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="text-center mb-16">
          <p className="text-[#C8973A] text-sm uppercase tracking-[0.3em] mb-3 font-semibold">
            Our Story
          </p>
          <h2 className="font-serif text-4xl md:text-5xl text-[#3A2A1A] font-bold mb-4 leading-tight">
            Rooted in Faith,<br />Growing with Purpose
          </h2>
          <div className="flex items-center justify-center gap-3 mt-5">
            <span className="block w-12 h-px bg-[#C8973A]" />
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-leaf-line text-[#2C4A3B] text-lg" />
            </div>
            <span className="block w-12 h-px bg-[#C8973A]" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative rounded-2xl overflow-hidden">
            <img
              src="/images/about.jpg"
              alt="The Mastro Family Farm grounds"
              className="w-full h-[420px] object-cover object-top"
            />
            <div className="absolute bottom-4 left-4 bg-[#2C4A3B]/90 text-white px-5 py-3 rounded-xl">
              <p className="text-xs uppercase tracking-wider text-[#C8D4B8]">Established</p>
              <p className="font-serif text-2xl font-bold">2024</p>
            </div>
          </div>

          <div>
            <p
              className="text-[#5C3D2E] text-base leading-relaxed mb-5"
              style={{ fontFamily: "'Nunito', sans-serif" }}
            >
              Welcome to the Mastro Family Farm.&nbsp; A small, humble plot of land where faith and family
              come together to cultivate something truly special. Nestled in God&apos;s great creation, we
              tend our soil, care for our animals, and gather the fruits of honest labor with grateful hearts.
            </p>
            <p
              className="text-[#5C3D2E] text-base leading-relaxed mb-8"
              style={{ fontFamily: "'Nunito', sans-serif" }}
            >
              Our small farm grows seasonal vegetables, raises happy free-range
              chickens, and tends honeybee colonies. Everything we do, we do as a family,
            </p>

            <div className="flex flex-col gap-5">
              {values.map(({ icon, label, desc }) => (
                <div key={label} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#2C4A3B]/12 shrink-0">
                    <i className={`${icon} text-[#2C4A3B] text-lg`} />
                  </div>
                  <div>
                    <p className="font-semibold text-[#3A2A1A] text-sm mb-0.5">{label}</p>
                    <p className="text-[#8B7355] text-sm leading-relaxed">{desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <p
              className="mt-8 text-[#7B5C3E] italic"
              style={{ fontFamily: "'Dancing Script', cursive", fontSize: '1.1rem' }}
            >
              &ldquo;Whatever you do, work at it with all your heart, as working for the Lord.&rdquo;
              &mdash; Colossians 3:23
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
